import { set } from 'lodash';
import { create } from 'zustand';

import { Order } from '@/libs/api';
import apiClient from '@/libs/api/client';

import { runTask } from './modal';

type PriceListState = {
  priceList: Order[];
  carbonTag: string;
  setCarbonTag: (carbonTag: string) => void;
  getPriceList: (arg: { carbonCreditId?: string; desc?: string; page?: number; sortby?: string }) => void;
};

export const usePriceListStore = create<PriceListState>((set) => ({
  priceList: [],
  carbonTag: '',
  setCarbonTag: (carbonTag) => {
    set({ carbonTag });
  },
  getPriceList: async (arg) => {
    const { carbonCreditId, desc, page, sortby } = arg;

    await runTask(async () => {
      const response = await apiClient.trade.tradeOrderSellList(carbonCreditId, desc, page, sortby);
      set({ priceList: response.results });
    });
  }
}));
